import React, { useState } from 'react'
import { formatMessage } from '../../../../locale'
import Paper from '../../../../ui-kit/Paper/Paper'
import Button from '../../../../ui-kit/Button/Button'
import { paths } from '../../../../config/paths'
import { TeamList } from './List/TeamList'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../store'
import {  useGetCourseProgressQuery, useLazyExportCourseProgressQuery } from '../../../../slices/dashboardApiSlice'
import { useNavigate, useParams } from 'react-router-dom';
import { BackButton, Title } from './TeamView.style'
import { LuArrowLeft } from 'react-icons/lu'
import { useIntlContext } from '../../../../locale/IntlProviderWrapper'

const TeamView: React.FC = () => {
  const { intl } = useIntlContext()
  const navigate = useNavigate()
  const { courseId } = useParams<{ courseId: string }>()
  const { data: teamData, isError } = useGetCourseProgressQuery({ id: courseId  })
  const [exportTeamResults] = useLazyExportCourseProgressQuery()

  const { userCompany, permissions } = useSelector((state: RootState) => state.auth)
  const canDo = (permission: string) => {
    return permissions && !!permissions[permission]
  }

  const handleExport = async (courseId: any) => {
    try {
        const blob = await exportTeamResults({ id: courseId }).unwrap(); 
        if (blob) {
            const url = URL.createObjectURL(blob); 
            const a = document.createElement('a'); 
            a.href = url;
            a.download = 'team_results.xlsx'; 
            document.body.appendChild(a);
            a.click(); 
            document.body.removeChild(a); 
            URL.revokeObjectURL(url);
        }
    } catch (error) {
        console.error('Error exporting team results:', error);
    }
};

  return(
    <Paper>
      <div style={{
        border: '1px solid rgba(234, 231, 242, 1)',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', borderRadius: '15px'
      }}>

       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 35 }}>
        <Title>{teamData?.data?.[0]?.title}</Title>

        <BackButton
          color={userCompany?.button_color}
          onClick={() => {
          navigate(paths.dashboard)
          }}
        >
        <LuArrowLeft />
          {intl.locale === 'sv' ? 'TILLBAKA TILL DASHBOARD' : 'BACK TO DASHHBOARD'}
          </BackButton>
        </div>

        <div style={{  borderTop: '1px solid rgba(0, 0, 0, 0.1)' }}/>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '30px 15px 0 25px' }}>
          <div/>
           {/*  {canDo('team: export team result') && ( */}
          {!isError && <Button
            appearance="primary"
            onClick={() => handleExport(courseId)}
          >
            {formatMessage({ id: 'dashboardCourse.exportToExcel', defaultMessage: 'Export to Excel' })}
          </Button>}
     {/*      )} */}

      </div>
        <TeamList  />
        </div>
    </Paper>
  )
}
export default TeamView;